<template lang='pug'>
div
  letter-head(v-if='estimate && request', :no-padding='true')
    .not-final NOT FINAL INVOICE
    .printable-title.top
      .title Estimate \#{{ estimate.id }}
  .printable-top-columns(v-if='request && estimate')
    el-row(:gutter='$rowGutter')
      el-col(:span='12')
        .top-column
          .top-title DELIVERY ADDRESS
          strong {{ request.customer_account_name }}
          div(v-if='address')
            | {{ address.address_line_1 }}
            div {{ address.address_line_2 }}
            div {{ address.city }}, {{ address.state }}
            div {{ address.zip_code }}
          div(v-if='request!== null && request.suite')
            | Suite: {{request.suite}} 
      el-col(:span='12')
        .top-column
          .top-title DELIVERY 
          div
            strong {{ request.name }}
          .standout {{ 'Del Date: '}}
            span.standout-accent {{ request.formatted_delivery_date }}
          .standout {{ 'Del Time: ' }}
            span.standout-accent {{ request.formatted_delivery_time }}
          .standout {{ 'Serves: '}}
            span.standout-accent {{ request.people }} People
    br


    .products-from(v-if='estimate', style='font-size: 0.8rem')
      | Products from&nbsp;
      strong.cl-primary {{ estimate.vendor_name }}

  page-content(v-loading='request === null || estimate === null ')
    el-table(
      :data='itemsWithoutTax'
    )
      el-table-column(prop='name', label='Name')
        template(slot-scope='scope')
          .product-name {{ scope.row.name }}
          .description {{ scope.row.description }}
          .description(v-if='scope.row.serves') serves {{ scope.row.serves }}
      el-table-column(prop='quantity', label='Quantity', width='100')
        template(slot-scope='scope', v-if='scope.row.type != "TAX" && scope.row.type != "DELIVERY"')
          | {{scope.row.quantity}}
      el-table-column(prop='sale_price_cents', label='Unit price', width='120')
        template(slot-scope='scope', v-if='scope.row.type != "TAX" && scope.row.type != "DELIVERY"')
          | {{$formatCents(scope.row.sale_price_cents) }}
      el-table-column(prop='total_cents', label='Total Price', width='140')
        template(slot-scope='scope', v-if='scope.row.type != "TAX"')
          | {{$formatCents(scope.row.total_cents) }}
    el-row(:gutter='$rowGutter', style='margin-top: 1rem;')
      el-col(:span='12') &nbsp;
      el-col(:span='12', v-if='totalCents && subtotalCents')
        .numeric-summary
          .label Subtotal
          .value {{ $formatCents(subtotalCents) }}
        .numeric-summary
          .label Tax
          .value {{ $formatCents(tax.sale_price_cents) }}
        .numeric-summary
          .label
            big Total
          .value
            big {{$formatCents(totalCents)}}
</template>

<script>
  import LetterHead from './LetterHead.vue'
  import PageContent from './PageContent.vue'
  import _ from 'underscore'

  function data(){
    return {
      address: null,
      request: null,
      estimate: null
    }
  }

  function mounted(){
    this.getData()
  }

  function getData(){
    const fullEstimate = `/estimates/${this.id}`
    return this.$simplecater.get(fullEstimate).then((r)=>{
      const estimateData = r.data.data;
      estimateData.items = estimateData.items.map(item => ({...item, total_cents: item.sale_price_cents * item.quantity}));
      this.estimate = estimateData
      this.$simplecater.get(`/requests/${this.estimate.request_id}`).then((r)=>{
        this.request = r.data.data;
        this.$simplecater.get(`/addresses/${this.request.address_id}`).then((r)=>{
          this.address = r.data.data
        }).catch(()=>{
          this.$message.error("Error loading the address information")
        })
      }).catch(()=>{
        this.$message.error("Error loading the request information")
      });
    }).catch(()=>{
      this.$message.error("Failed to load the list of products")
    })
  }
  const methods = { getData };

  const components = { LetterHead, PageContent }

  const props = {
    id: { required: true }
  }

  const computed = {
    totalCents ( ) {
      return ( this.estimate )? _.reduce(this.estimate.items, ( acc, i ) => (acc + i.total_cents), 0 ) : 0
    },

    itemsWithoutTax ( ) {
      return ( this.estimate )? _.filter(this.estimate.items, ( x ) => (x.type != "TAX")) : []
    },

    tax ( ) {
      return ( this.estimate )? _.find(this.estimate.items, ( x ) => (x.type === "TAX")) : null
    },

    subtotalCents ( ) {
      return _.reduce(this.estimate.items, (memo, i) => {
        return ( i.type != "TAX" )? memo + (i.sale_price_cents * i.quantity) : memo
      }, 0)
    },
  }

  export default { data, components, mounted, methods, props, computed }
</script>

<style scoped lang="sass">

  .standout
    font-weight: bold
    color: #444

  .description
    font-style: italic
    font-size: 12px
    word-break: break-word
    color: #888

  .not-final
    font-size: 20px
    font-weight: bold
    color: #909399

  .printable-title.top
    margin-top: 0px

  .standout-accent
    color: #dd711f

  .serves
    color: #444


</style>



// WEBPACK FOOTER //
// src/print/EstimatePDF.vue